var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAssignedUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#1C2154"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-709 -263) translate(264 234) translate(445 30) translate(4.984 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.016,
    cy: 9,
    r: 7.677,
    strokeWidth: 2.646
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.5,
    d: "M36.915 29.617l-5.272-.806-2.36-5.021c-.184-.387-.79-.387-.974 0l-2.36 5.02-5.273.807c-.206.034-.368.182-.433.386-.065.205-.01.432.14.58l3.822 3.907-.898 5.51c-.033.216.043.431.216.556.163.125.39.148.574.046L28.796 38l4.72 2.602c.076.045.162.068.249.068.108 0 .227-.034.314-.114.162-.125.249-.34.216-.556l-.898-5.51 3.821-3.907c.152-.148.206-.375.141-.58-.076-.204-.238-.363-.444-.386z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M18.151 40.64H4.001C1.792 40.64 0 38.85 0 36.64c0 0 0 0 0 0 0-9.94 6.638-17.998 14.826-17.998 3.479 0 6.677 1.454 9.206 3.889"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssignedUser);
export default __webpack_public_path__ + "static/media/icon-assigned-user.f8706b7a.svg";
export { ForwardRef as ReactComponent };